require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// /Users/jb/Code/grupob/~/core-js/fn/regexp/escape.js
// module id = 138
// module chunks = 0